import React from 'react';
import ProfileSettings from 'pages/ProfileSettings';
import MailIcon from '@material-ui/icons/Mail'
import { FormattedMessage } from 'react-intl';


import { ReactComponent as DashboardIcon } from 'assets/svgs/sidemenu/home.svg';
import { ReactComponent as IconDocuments } from 'assets/svgs/sidemenu/documents.svg';
import { ReactComponent as IconCatalouge } from 'assets/svgs/sidemenu/catalogues.svg';
import { ReactComponent as IconAccount } from 'assets/svgs/sidemenu/profile.svg';
import { ReactComponent as IconLogout } from 'assets/svgs/sidemenu/logout.svg';
import { ReactComponent as IconFaq } from 'assets/svgs/sidemenu/faq.svg';

export default function GetMenus() {
  return {
    top: [
      {
        id: 'notifications',
        text: <FormattedMessage id="navbar.notifications" />,
        icon: <MailIcon className="side-bar-svg" />,
        components: ProfileSettings,
        index: 0,
      },
    ],
    middle: [
      {
        id: 'dashboard',
        text: <FormattedMessage id="navbar.dashboard" />,
        icon: <DashboardIcon className="side-bar-svg" />,
        url: '/dashboard',
        index: 11,
      },
      {
        id: 'documents',
        text: <FormattedMessage id="navbar.documents" />,
        icon: <IconDocuments className="side-bar-svg" />,
        url: '/documents',
        index: 12,
      },
      // {
      //   id: 'applications',
      //   text: <FormattedMessage id="navbar.services" />,
      //   icon: <IconService className="side-bar-svg" />,
      //   url: '/applications',
      //   index: 13,
      // },
      {
        id: 'catalogue',
        text: <FormattedMessage id="navbar.catalogue" />,
        icon: <IconCatalouge className="side-bar-svg" />,
        url: '/catalogue',
        index: 13,
      },
    ],
    bottom: [
      {
        id: 'profile',
        text: <FormattedMessage id="navbar.profile" />,
        icon: <IconAccount className="side-bar-svg" />,
        url: '/profile',
        index: 21,
      },
      {
        id: 'exit',
        text: <FormattedMessage id="navbar.exit" />,
        icon: <IconLogout className="side-bar-svg" />,
        index: 22,
      },
      {
        id: 'helpcenter',
        text: <FormattedMessage id="navbar.helpcenter" />,
        icon: <IconFaq className="side-bar-svg" />,
        index: 22,
        children: [
          {
            id: 'faq',
            text: <FormattedMessage id="navbar.faq" />,
            url: '/faq',
            index: 100,
          },
          {
            id: 'tutorial',
            text: <FormattedMessage id="navbar.tutorial" />,
            url: '/tutorial',
            index: 101,
          },
          {
            id: 'contact',
            text: <FormattedMessage id="navbar.contact" />,
            index: 102,
          }
        ]
      },
    ],
  };
}
